import { render, staticRenderFns } from "./aiMailView.vue?vue&type=template&id=fc1332be&scoped=true"
import script from "./aiMailView.vue?vue&type=script&lang=js"
export * from "./aiMailView.vue?vue&type=script&lang=js"
import style0 from "./aiMailView.vue?vue&type=style&index=0&id=fc1332be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1332be",
  null
  
)

export default component.exports